import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flex, flexAbsoluteCenter, flexDirection, m, mb, onDesktop, ph, position, w100} from "@pg-design/helpers-css";
import {Placeholder} from "@pg-design/image-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {HeaderBox, HeaderBoxType} from "../atoms/HeaderBox";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesTextFromType} from "../utils/get_from_prices_type";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesHeader = (props: IProps) => {
    const pictures = getHeaderPictures(props.region?.slug);

    const {dateLabel, dataToRender} = usePricesHeaderData(props.region?.slug);

    return (
        <div css={headerHolder}>
            <div css={textHolder}>
                <SeoMainHeadline variant="headline_1" align="center" css={mb(1)} highlight prefixContent="Poznaj średnie">
                    {getPricesTextFromType(props.type)} {props.region?.name_declension_where || "w Polsce"}
                </SeoMainHeadline>
                {dateLabel && (
                    <Text as="span" variant="body_copy_0">
                        {dateLabel}
                    </Text>
                )}
            </div>

            {pictures ? (
                <Picture
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919},
                        {minWidthPX: 1919, src: pictures.xl, height: 1102, width: 2560}
                    ]}
                    alt="header"
                />
            ) : (
                <div css={placeholderStyle}>
                    <Placeholder />
                </div>
            )}

            {dataToRender && (
                <BoxesHolder pictureExist={!!pictures}>
                    <HeaderBox type={HeaderBoxType.PRICE_M2} data={dataToRender.avr_price_m2} />

                    <HeaderBox type={HeaderBoxType.PRICE} data={dataToRender.avr_price} />

                    <HeaderBox type={HeaderBoxType.FLATS_COUNT} data={dataToRender.offers_count} />
                </BoxesHolder>
            )}
        </div>
    );
};

const headerHolder = css`
    ${mb(5)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
`;

const textHolder = css`
    ${m(4, 1.5)};
    ${flex("flex-start", "center")};
    ${flexDirection("column")};

    ${onDesktop(css`
        ${m(4, 0)};
        ${flexAbsoluteCenter};
    `)};
`;

const BoxesHolder = styled.div<{pictureExist: boolean}>`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(3)};
    ${flexDirection("column")};
    transform: translateY(${(props) => (props.pictureExist ? "-15%" : "-15%")});
    ${ph(2)};
    ${w100};

    ${(props) =>
        onDesktop(css`
            ${flexDirection("row")};
            transform: translateY(${props.pictureExist ? "-50%" : "-50%"});
        `)};
`;

const placeholderStyle = css`
    ${w100};
    min-height: 420px;
    ${position("relative")};
`;
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flex, flexAbsoluteCenter, flexDirection, m, mb, onDesktop, ph, position, w100} from "@pg-design/helpers-css";
import {Placeholder} from "@pg-design/image-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

import {SeoMainHeadline} from "../../../atoms/SeoMainHeadline";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {HeaderBox, HeaderBoxType} from "../atoms/HeaderBox";
import {getHeaderPictures} from "../helpers/get_header_pictures";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesTextFromType} from "../utils/get_from_prices_type";
import {usePricesHeaderData} from "../utils/use_prices_header_data";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesHeader = (props: IProps) => {
    const pictures = getHeaderPictures(props.region?.slug);

    const {dateLabel, dataToRender} = usePricesHeaderData(props.region?.slug);

    return (
        <div css={headerHolder}>
            <div css={textHolder}>
                <SeoMainHeadline variant="headline_1" align="center" css={mb(1)} highlight prefixContent="Poznaj średnie">
                    {getPricesTextFromType(props.type)} {props.region?.name_declension_where || "w Polsce"}
                </SeoMainHeadline>
                {dateLabel && (
                    <Text as="span" variant="body_copy_0">
                        {dateLabel}
                    </Text>
                )}
            </div>

            {pictures ? (
                <Picture
                    sources={[
                        {minWidthPX: 0, src: pictures.xs, height: 360, width: 448},
                        {minWidthPX: 360, src: pictures.sm, height: 600, width: 448},
                        {minWidthPX: 600, src: pictures.md, height: 588, width: 1366},
                        {minWidthPX: 1366, src: pictures.lg, height: 826, width: 1919},
                        {minWidthPX: 1919, src: pictures.xl, height: 1102, width: 2560}
                    ]}
                    alt="header"
                />
            ) : (
                <div css={placeholderStyle}>
                    <Placeholder />
                </div>
            )}

            {dataToRender && (
                <BoxesHolder pictureExist={!!pictures}>
                    <HeaderBox type={HeaderBoxType.PRICE_M2} data={dataToRender.avr_price_m2} />

                    <HeaderBox type={HeaderBoxType.PRICE} data={dataToRender.avr_price} />

                    <HeaderBox type={HeaderBoxType.FLATS_COUNT} data={dataToRender.offers_count} />
                </BoxesHolder>
            )}
        </div>
    );
};

const headerHolder = css`
    ${mb(5)};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
`;

const textHolder = css`
    ${m(4, 1.5)};
    ${flex("flex-start", "center")};
    ${flexDirection("column")};

    ${onDesktop(css`
        ${m(4, 0)};
        ${flexAbsoluteCenter};
    `)};
`;

const BoxesHolder = styled.div<{pictureExist: boolean}>`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(3)};
    ${flexDirection("column")};
    transform: translateY(${(props) => (props.pictureExist ? "-15%" : "-15%")});
    ${ph(2)};
    ${w100};

    ${(props) =>
        onDesktop(css`
            ${flexDirection("row")};
            transform: translateY(${props.pictureExist ? "-50%" : "-50%"});
        `)};
`;

const placeholderStyle = css`
    ${w100};
    min-height: 420px;
    ${position("relative")};
`;
